import { supabase } from "@/integrations/supabase/client";
import type { ControleProjeto } from "@/types/controle-projeto";

// Renovações já combinadas ('planejado', sql/282) ficam fora das listas: aparecem
// penduradas no período em curso da cadeia, que mostra o chip e troca Renovar por
// "Renovar com o período planejado".
export async function fetchPlanejados(): Promise<ControleProjeto[]> {
  const { data, error } = await supabase
    .from("controle_projetos")
    .select("id, agencia_id, freelancer_id, area_atuacao, valor_projeto, data_inicio, data_conclusao, created_at, status, projeto_original_id, numero_renovacoes")
    .is("deleted_at", null)
    .eq("status", "planejado");

  if (error) throw error;
  return (data || []) as ControleProjeto[];
}

export function raizDaCadeia(projeto: Pick<ControleProjeto, "id" | "projeto_original_id">): string {
  return projeto.projeto_original_id || projeto.id;
}

/** Pendura os planejados de cada cadeia, em ordem de início, no período ativo dela. */
export function anexarPlanejados(projetos: ControleProjeto[], planejados: ControleProjeto[]): ControleProjeto[] {
  if (planejados.length === 0) return projetos;
  const porCadeia = new Map<string, ControleProjeto[]>();
  for (const planejado of planejados) {
    const raiz = raizDaCadeia(planejado);
    porCadeia.set(raiz, [...(porCadeia.get(raiz) ?? []), planejado]);
  }
  for (const lista of porCadeia.values()) {
    lista.sort((a, b) => (a.data_inicio ?? "").localeCompare(b.data_inicio ?? ""));
  }
  return projetos.map((projeto) => {
    const daCadeia = projeto.status === "ativo" ? porCadeia.get(raizDaCadeia(projeto)) : undefined;
    return daCadeia ? { ...projeto, planejados: daCadeia } : projeto;
  });
}
